// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor4 from '@/game/prefabs/World/Mentors/Mentor4';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level17 extends TilemapScene {
  constructor() {
    super('Level17');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // winter_biome_2
    const winter_biome_2 = this.add.tilemap('winter-biome-2');
    winter_biome_2.addTilesetImage(
      'winter forest wang tiles (snowy)',
      'winter forest wang tiles (snowy)',
    );
    winter_biome_2.addTilesetImage(
      'winter forest (snowy)',
      'winter forest (snowy)',
    );
    winter_biome_2.addTilesetImage(
      'winter trees (snowy) 80x112',
      'winter trees (snowy) 80x112',
    );
    winter_biome_2.addTilesetImage('collision', 'collision & alpha');

    // terrain_1
    winter_biome_2.createLayer(
      'terrain',
      ['winter forest wang tiles (snowy)'],
      0,
      0,
    );

    // deco
    winter_biome_2.createLayer('deco 1', ['winter forest (snowy)'], 0, 0);

    // cOLLISION_1
    const cOLLISION_1 = winter_biome_2.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 784, 88);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 728, 280);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 488, 280);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 296, 368);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 208, 80);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 48, 528);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 432, 120);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 144, 48);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      568,
      304,
      'winter trees (snowy) 80x',
      0,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(
      this,
      568,
      144,
      'winter trees (snowy) 80x',
      0,
    );
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      408,
      112,
      'winter trees (snowy) 80x',
      0,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      312,
      224,
      'winter trees (snowy) 80x',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      456,
      240,
      'winter trees (snowy) 80x',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      504,
      400,
      'winter trees (snowy) 80x',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      296,
      496,
      'winter trees (snowy) 80x',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      728,
      192,
      'winter trees (snowy) 80x',
      1,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      808,
      288,
      'winter trees (snowy) 80x',
      1,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      504,
      224,
      'winter trees (snowy) 80x',
      1,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      88,
      144,
      'winter trees (snowy) 80x',
      1,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      424,
      560,
      'winter trees (snowy) 80x',
      1,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      88,
      520,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      360,
      448,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      408,
      464,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      424,
      320,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      264,
      288,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      520,
      128,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      552,
      336,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      680,
      336,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      768,
      208,
      'winter (snowy) 32x',
      2,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      616,
      224,
      'winter (snowy) 48x',
      0,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      272,
      96,
      'winter (snowy) 32x',
      2,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      632,
      48,
      'winter (snowy) 48x',
      0,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      328,
      256,
      'winter trees (snowy) 80x',
      2,
    );
    this.add.existing(forestTree_23);

    // mentor
    const mentor = new Mentor4(this, 704, 72);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 152, 168);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 384, 296);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 632, 304);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 648, 128);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 16;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 16;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 16;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 16;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 16;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 16;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 16;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 16;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 16;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 16;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.winter_biome_2 = winter_biome_2;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor4;
  private winter_biome_2!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.winter_biome_2,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
